export const SET_FOLDER_STATE = 'folders/SET_FOLDER_STATE'
